import { render } from "./ProjectsListComponent.vue?vue&type=template&id=cf7e4f52"
import script from "./ProjectsListComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__